module.exports = __webpack_public_path__ + "img/login-ha-register-bg-5714f4cde62af7233996b1261cad32df.svg";